<template>
  <div>
    <p>
      <slot />
    </p>
    <el-autocomplete
      v-model="text"
      :placeholder="placeholder"
      :fetch-suggestions="querySearchAsync"
      size="large"
      value-key="autocompleteKeyName"
      :disabled="disabled"
      :debounce="1000"
      :clearable="true"
      @select="handleSelect"
      @clear="onClear"
    />
    <fast-links
      v-if="!disabled && fast"
      :fastlinks="fastlinks"
      @selectedItem="fastlinkselect"
    >
      Быстрый выбор:
    </fast-links>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import FastLinks from './FastLinks'

export default {
  name: 'AutocompleteCustom',
  components: { FastLinks },
  props: {
    name: {
      type: String,
      default: '',
    },
    lib: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    relation: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Выберите',
    },
    edit: {
      type: Object,
      default: () => {},
    },
    fast: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      text: '',
    }
  },
  computed: {
    ...mapGetters({ getFastLinks: 'fastlink/getFastLinks' }),
    repository() {
      return RepositoryFactory.get(this.lib.controller)
    },
    isFastlinks() {
      return Boolean(this.getFastLinks(this.name).length)
    },
    fastlinks() {
      return this.getFastLinks(this.name, this.relation)
    },
  },
  watch: {
    edit(val) {
      if (val && val.id) {
        this.fastlinkselect(val)
      } else if (val && val.clear) {
        this.text = ''
        this.onClear()
      }
    },
  },
  created() {
    if (!this.isFastlinks) {
      this.initLinks(this.name)
    }

    if (this.edit && this.edit.id) {
      this.fastlinkselect(this.edit)
    }
  },
  methods: {
    ...mapActions({ initLinks: 'fastlink/init', pushLink: 'fastlink/push' }),
    querySearchAsync(queryString, cb) {
      if (queryString.length < 4) {
        cb([])

        return false
      }
      const { params } = this.lib

      params.query = queryString

      this.repository
        .get('', { params })
        .then(response =>
          cb(this.compositeKeyName(response.data, this.lib.keyName)),
        )
        .catch(error => console.log(error))
    },
    selectItem(
      id,
      name,
      coords_lat,
      coords_lon,
      relation = this.relation,
      fast = false,
    ) {
      const item = { name, id, coords_lat, coords_lon }

      this.$emit('selected', item, fast)
      item.relation = relation
      this.pushLink({ item, name: this.name })
    },
    handleSelect(item) {
      this.selectItem(
        item.id,
        item.autocompleteKeyName,
        item.coords_lat,
        item.coords_lon,
      )
    },
    onClear() {
      this.$emit('selected', {})
    },
    fastlinkselect(item) {
      this.text = item.name
      this.selectItem(
        item.id,
        item.name,
        item.coords_lat,
        item.coords_lon,
        item.relation,
        item.fast,
      )
    },
    compositeKeyName(data, keys) {
      return data.map(item => {
        item.autocompleteKeyName = ''
        keys.forEach(key => {
          if (key !== ' ') {
            item.autocompleteKeyName += item[key]
          } else {
            item.autocompleteKeyName += key
          }
        })

        if (item.parents && item.parents.length) {
          item.parents.forEach(d => {
            item.autocompleteKeyName += ', '
            keys.forEach(key => {
              if (key !== ' ') {
                item.autocompleteKeyName += d[key]
              } else {
                item.autocompleteKeyName += key
              }
            })
          })
        }

        return item
      })
    },
  },
}
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}

.el-input__inner {
  height: 54px;
}
</style>
